import { render, staticRenderFns } from "./VerDetalleDescargaActividadModal.vue?vue&type=template&id=5007f556&"
import script from "./VerDetalleDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5007f556', component.options)
    } else {
      api.reload('5007f556', component.options)
    }
    module.hot.accept("./VerDetalleDescargaActividadModal.vue?vue&type=template&id=5007f556&", function () {
      api.rerender('5007f556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/verDetalle/VerDetalleDescargaActividadModal.vue"
export default component.exports